// Lib
import React from 'react';

// Components
import Icon from '../../components/icons/Icon';

// Styles
import './DragLayerErrorRenderer.scss';

const DragLayerErrorRenderer = () => (
    <div className="DragLayerErrorRenderer">
        <div className="content">
            <Icon name="cross-small" /> An error occurred while dragging
        </div>
    </div>
);

export default DragLayerErrorRenderer;
